import { useCallback, useEffect } from 'react';

import Layout from 'domain/entity/layout';
import { ReadLayoutsCriteriaBuilder } from 'use-case/layout/read/readLayoutsCriteria';
import { DefaultUseCaseState } from 'adapter/in/common/hooks/useCase';
import { useLayouts } from 'adapter/in/dashboards/context/Layouts';

export const useReadLayouts = (dashboardId: string): DefaultUseCaseState<Layout[]> & { reset: () => void } => {
    const { readIsLoading, readResult, readError, read, readReset } = useLayouts();

    const handleRead = useCallback(() => {
        read(ReadLayoutsCriteriaBuilder.create().withDashboardId(dashboardId).build());
    }, [dashboardId]);

    useEffect(() => {
        handleRead();
    }, [dashboardId]);

    return {
        isLoading: readIsLoading,
        data: readResult,
        error: readError,
        reset: readReset,
    };
};
